/* eslint-disable i18next/no-literal-string -- TanStack cache key segments */
/**
 * `entities/project-tag` TanStack Query key factory.
 *
 * Workspace-scoped tag pool — shared by project tags and folder tags so the
 * cache is consistent across both surfaces. Key shape: `['tags', 'workspace', workspaceId]`.
 *
 * Note: tag keys live under the `'tags'` root (NOT under `'projects'` or `'project'`)
 * because tags are workspace-scoped, not project-scoped. Invalidating a project's
 * caches must NOT clobber the workspace-wide tag cache.
 */

export const PROJECT_TAG_QUERY_KEYS = {
  /** Constant tuple for invalidating EVERY project-tag cache. */
  all: ['tags'] as const,

  /**
   * Workspace-scoped tag list for a given workspace. The workspaceId slot is the
   * 3rd element so partial-match invalidation via `.slice(0, 2)` clears every
   * workspace.
   */
  workspace: (workspaceId: string) => ['tags', 'workspace', workspaceId] as const,
} as const;
